export default __webpack_public_path__ + "static/media/IMG_20250415_222436.9408a96d.jpg";